import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    codigo: '',
    nombre: '',
    // gastos: false,
    // honorarios: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, cuentaId) {
        state.id = cuentaId;
        state.codigo = '';
        state.nombre = '';
        // state.gastos = false;
        // state.honorarios = false;
        state.rowVersion = null;
    },
    'SET_CUENTA'(state, cuenta) {
        state.codigo = cuenta.codigo.trim();
        state.nombre = cuenta.nombre.trim();
        // state.gastos = cuenta.gastos;
        // state.honorarios = cuenta.honorarios;
        state.rowVersion = cuenta.rowVersion;
    },

};

const actions = {
    inicializar: ( { commit }, cuentaId )  => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', cuentaId);

            if (cuentaId != 0) {
                apiAxios.get('cuentas/' + cuentaId + '/abm')
                .then(res => {
                    commit('SET_CUENTA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let error = '';

            let codigo = '';
            if (!isNaN(state.codigo)) {
                let numeroCodigo = parseInt(state.codigo);
                codigo = numeroCodigo.toString().padStart(3, '0');
            } else {
                save = false;
                error = 'El código de cuenta no es válido. Verifique la información ingresada.';
            }

            if (save) {
                let cuenta= {
                    // codigo: state.codigo.trim().toUpperCase(),
                    codigo: codigo,
                    nombre: state.nombre.trim().toUpperCase(),
                    // gastos: (/true/i).test(state.gastos),
                    // honorarios: (/true/i).test(state.honorarios)
                }

                let url = 'cuentas';
                if (state.id != 0) {
                    url += '/' + state.id;
                    cuenta.rowVersion = state.rowVersion;
                }
                apiAxios.post(url, cuenta)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(error);
            }
        })
    },
    delete ( {}, cuentaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('cuentas/' + cuentaId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}